// extracted by mini-css-extract-plugin
export var tosLink = "_8x-0";